import { render, staticRenderFns } from "./posterList.vue?vue&type=template&id=46171755&scoped=true"
import script from "./posterList.vue?vue&type=script&lang=js"
export * from "./posterList.vue?vue&type=script&lang=js"
import style0 from "./posterList.vue?vue&type=style&index=0&id=46171755&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46171755",
  null
  
)

export default component.exports